module.exports = __webpack_public_path__ + "img/slide-3-md.d1fe41f.webp";